// import { Autocomplete, Grid, Pagination, PaginationItem, TextField, Typography } from "@mui/material";
// import {DataGrid, GridCsvExportMenuItem, GridToolbarContainer, GridToolbarExport, GridToolbarExportContainer, } from "@mui/x-data-grid";
// import React, { Fragment, Suspense, memo, useState } from "react";
// import { useStyle } from "./style";
// import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// import Loader from "../loader/loader";
// import { useLocation } from "react-router-dom";

// const CustomDataGrid = ({ props }) => {
//     const classes = useStyle()
//     const location = useLocation()
//     const handleChange = (event, newValue) => {
//       props.setRowsPerPage(newValue);
//     }
//   function CustomToolbar() {
//     return (
//       <GridToolbarContainer>
//       <GridToolbarExportContainer>
//       <GridCsvExportMenuItem />
//       </GridToolbarExportContainer>
//     </GridToolbarContainer>
//     );
//   }
// console.log(location.pathname)
//   const handleSearch = (e) =>{
//     props.setSearch(e.target.value)
//   }
 
//   const CustomFooter = () => {
//     return(
//      <Grid container className={classes.footer}>
//        <Grid className={classes.paginationOne}>
//          <Autocomplete
//            disablePortal
//            id="page"
//            value={props.rowsPerPage}
//            onChange={handleChange}
//            options={props.pageOption}         
//            getOptionLabel={(option) => option.toString()}               
//            disableClearable
//            renderInput={(params) => 
//              <TextField {...params} className={classes.paginationAutocomplete}  
//            disabled
//            sx={{color:"red"}}
//             />
//            }
//            size="small"/>
//            <Typography variant="body 1" color={"#ccc"} ml="6px">rows per page</Typography>
//        </Grid>

//        <Grid>
//          <Pagination 
//           color="primary" 
//           size="small"
//           count={Math.ceil(props.pageCount / props.rowsPerPage)}
//           page={props.page + 1}
//           onChange={(event, newPage) => props.setPage(newPage - 1)}
//           boundaryCount={1}
//           renderItem={(item) => (
//            <PaginationItem
//              className={classes.pagination}
//              slots={{ previous: ArrowLeftIcon , next: ArrowRightIcon  }}
//              {...item}
            
//            />
//          )}
//           />
//        </Grid>
//      </Grid>
//     )
//  }
//   return (
//     <Fragment>
//       <Grid className="bg-white pt-2" >
//         <Grid className="flex justify-end mr-3 mb-5">
//           <TextField size="small" placeholder= {location.pathname == "/outlets/phonePayLogs" ? 'Search Phone Number' : 'Search'}  onChange={(e)=>handleSearch(e)}/>
//         </Grid>
//         <Suspense fallback={<Loader />}>
        
//           <DataGrid
//             // autoHeight
//             rows={props.rows}
//             columns={props.columns}
//             density="compact"
//             slots={{ toolbar: CustomToolbar,footer:CustomFooter }}
//             disableRowSelectionOnClick={true}
//             showColumnVerticalBorder={true}
//             disableColumnFilter
//             disableColumnSelector
//             disableDensitySelector
//             paginationModel={{page : props.page, pageSize: props.rowsPerPage}}
//             sx={{ '--DataGrid-overlayHeight': '300px', height:'56vh',width:"100%" ,overflowX:"auto"}}
//           />
        
//         </Suspense>
//       </Grid>
//     </Fragment>
//   );
// };

// export default memo(CustomDataGrid);
import { Autocomplete, Button, Grid, Pagination, PaginationItem, TextField, Typography } from "@mui/material";
import {DataGrid, GridCsvExportMenuItem, GridToolbarContainer, GridToolbarExport, GridToolbarExportContainer, } from "@mui/x-data-grid";
import React, { Fragment, Suspense, memo, useState } from "react";
import { useStyle } from "./style";
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Loader from "../loader/loader";
import { useLocation } from "react-router-dom";

const CustomDataGrid = ({ props ,OnAssignProduct}) => {
    const classes = useStyle()
    const location = useLocation()
    const handleChange = (event, newValue) => {
      props.setRowsPerPage(newValue);
    }
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
      <GridToolbarExportContainer>
      <GridCsvExportMenuItem />
      </GridToolbarExportContainer>
    </GridToolbarContainer>
    );
  }
console.log(location.pathname)
  const handleSearch = (e) =>{
    props.setSearch(e.target.value)
  }
 
  const CustomFooter = () => {
    return(
     <Grid container className={classes.footer}>
       <Grid className={classes.paginationOne}>
         <Autocomplete
           disablePortal
           id="page"
           value={props.rowsPerPage}
           onChange={handleChange}
           options={props.pageOption}         
           getOptionLabel={(option) => option.toString()}               
           disableClearable
           renderInput={(params) => 
             <TextField {...params} className={classes.paginationAutocomplete}  
           disabled
           sx={{color:"red"}}
            />
           }
           size="small"/>
           <Typography variant="body 1" color={"#ccc"} ml="6px">rows per page</Typography>
       </Grid>

       <Grid>
         <Pagination 
          color="primary" 
          size="small"
          count={Math.ceil(props.pageCount / props.rowsPerPage)}
          page={props.page + 1}
          onChange={(event, newPage) => props.setPage(newPage - 1)}
          boundaryCount={1}
          renderItem={(item) => (
           <PaginationItem
             className={classes.pagination}
             slots={{ previous: ArrowLeftIcon , next: ArrowRightIcon  }}
             {...item}
            
           />
         )}
          />
       </Grid>
     </Grid>
    )
 }
  return (
    <Fragment>
      <Grid className="bg-white pt-2" >
        {/* <Grid className="flex justify-end mr-3 mb-5">
          <TextField size="small" placeholder= {location.pathname == "/outlets/phonePayLogs" ? 'Search Phone Number' : 'Search'}  onChange={(e)=>handleSearch(e)}/>
        </Grid> */}
         <Grid
      container
      // justifyContent="space-between"
      sx={{
        justifyContent: location.pathname === '/master/product' ? 'space-between' : 'flex-end',
        // marginRight: 3,
        // marginBottom: 5,
      }}
      // {location.pathname === "/master/product" ? justifyContent="space-between" : justifyContent="end"}
      // justifyContent="space-between"
      alignItems="center"
      className="mr-3 mb-5"
    >
      {/* <Button
        variant="contained"
        size="small"
        sx={{ fontSize: 20 }}
        onClick={() => OnAssignProduct()}
      >
        Assign Product
      </Button> */}
       {location.pathname === "/master/product" && (
            <Button
              variant="contained"
              size="small"
              sx={{ fontSize: 20 }}
              onClick={OnAssignProduct}
            >
              Assign Product
            </Button>
          )}
      <TextField
        size="small"
    
        placeholder={
          location.pathname === '/outlets/phonePayLogs'
            ? 'Search Phone Number'
            : 'Search'
        }
        onChange={(e) => handleSearch(e)}
      />
      {/* <Grid className="flex justify-end mr-3 mb-5">
          <TextField size="small" placeholder= {location.pathname == "/outlets/phonePayLogs" ? 'Search Phone Number' : 'Search'}  onChange={(e)=>handleSearch(e)}/>
        </Grid> */}
    </Grid>
        <Suspense fallback={<Loader />}>
        
          <DataGrid
            // autoHeight
            rows={props.rows}
            columns={props.columns}
            density="compact"
            slots={{ toolbar: CustomToolbar,footer:CustomFooter }}
            disableRowSelectionOnClick={true}
            showColumnVerticalBorder={true}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            paginationModel={{page : props.page, pageSize: props.rowsPerPage}}
            sx={{ '--DataGrid-overlayHeight': '300px', height:'56vh',width:"100%" ,overflowX:"auto"}}
            // getRowHeight={() => 'auto'}
          />
        
        </Suspense>
      </Grid>
    </Fragment>
  );
};

export default memo(CustomDataGrid);
